<table>
  <tr>
    <td class="spacer"></td>
    <td></td>
    <ng-container *ngrxLet="selectProductByRoleDict$; let p">
      <td class="role-cell"></td>
      <td class="role-cell"></td>
      <td class="role-cell">
        <!--        {{ selectTrialDays$ | ngrxPush }} Day Trial-->
      </td>
      <td class="role-cell"></td>
    </ng-container>
  </tr>

  <tr>
    <td class="spacer"></td>
    <td class="border-right feature-name-cell"></td>
    <ng-container *ngrxLet="selectProductByRoleDict$; let p">
      <td class="tier-name border-top-left">
        {{ p[roles.EARLY_ADOPTER]?.name?.toUpperCase() }}
      </td>
      <td class="tier-name border-top border-right">
        {{ p[roles.COLLABORATOR]?.name?.toUpperCase() }}
      </td>
      <td class="tier-name border-top border-right">
        {{ p[roles.PERSONAL]?.name?.toUpperCase() }}
      </td>
      <td class="tier-name border-top-right">
        {{ p[roles.BAND]?.name?.toUpperCase() }}
      </td>
    </ng-container>
  </tr>

  <tr>
    <td class="spacer"></td>
    <td class="border-right feature-name-cell"></td>
    <ng-container *ngrxLet="selectPriceByMonthDict$; let p">
      <td class="tier-monthly-price border-right">
        {{ formatCurrency(p[roles.EARLY_ADOPTER]) }} / Month
      </td>
      <td class="tier-monthly-price border-right">FREE</td>
      <td class="tier-monthly-price border-right">
        {{ formatCurrency(p[roles.PERSONAL]) }} / Month
      </td>
      <td class="tier-monthly-price border-right">
        {{ formatCurrency(p[roles.BAND]) }} / Month
      </td>
    </ng-container>
  </tr>

  <tr>
    <td class="spacer"></td>
    <td class="border-right"></td>
    <ng-container *ngrxLet="selectPriceByYearDict$; let p">
      <td class="border-right border-top cell-padding">
        <span class="tier-yearly-price"
          >{{ formatCurrency(p[roles.EARLY_ADOPTER]) }} / Year</span
        >
      </td>
      <td class="border-right"></td>
      <td class="border-right border-top cell-padding">
        <span class="tier-yearly-price"
          >{{ formatCurrency(p[roles.PERSONAL]) }} / Year</span
        ><br />
        <strong>( {{ p[roles.PERSONAL].description }} )</strong>
      </td>
      <td class="border-right border-top cell-padding">
        <span class="tier-yearly-price"
          >{{ formatCurrency(p[roles.BAND]) }} / Year</span
        ><br />
        <strong>( {{ p[roles.PERSONAL].description }} )</strong>
      </td>
    </ng-container>
  </tr>

  <tr>
    <td class="spacer"></td>
    <td class="border-right"></td>
    <td
      class="border-right border-top description left"
      data-role="early-adopter">
      Terms and conditions apply to<br />becoming an early adopter.
    </td>
    <td class="border-right border-top description left" data-role="reviewer">
      Contribute to other projects only. All costs for contribution are the
      project owner's responsibility.
    </td>
    <td class="border-right border-top description left" data-role="personal">
      Can invite collaborators and reviewers to your project.
    </td>
    <td class="border-right border-top description left" data-role="band">
      Can invite collaborators and reviewers to your project.
    </td>
  </tr>

  <tr>
    <td class="spacer"></td>
    <td class="border-right"></td>
    <td class="border-right" data-role="early-adopter">
      <button mat-flat-button color="primary" (click)="learnMoreEarlyAdopter()">
        LEARN MORE
      </button>
    </td>
    <td class="border-right description left" data-role="reviewer">
      Must be invited to a project as a reviewer.
    </td>
    <td class="border-right description left" data-role="personal"></td>
    <td class="border-right" data-role="band"></td>
  </tr>

  <tr>
    <td class="title left border-left border-top-left" colspan="2">
      STORAGE<sup>&nbsp;</sup>
    </td>
    <ng-container *ngrxLet="selectProductByRoleDict$; let p">
      <td class="title border-top border-right border-bottom">
        {{ p[roles.EARLY_ADOPTER]?.metadata?.baseStorageGB | storage
        }}<sup>*</sup>
      </td>
      <td class="title border-top border-right border-bottom">
        {{ p[roles.COLLABORATOR]?.metadata?.baseStorageGB | storage }}
      </td>
      <td class="title border-top border-right border-bottom">
        {{ p[roles.PERSONAL]?.metadata?.baseStorageGB | storage }}<sup>*</sup>
      </td>
      <td class="title border-top border-right border-bottom">
        {{ p[roles.BAND]?.metadata?.baseStorageGB | storage }}<sup>*</sup>
      </td>
    </ng-container>
  </tr>

  <tr>
    <td class="title left border-top border-left border-right" colspan="2">
      DAW FEATURES
    </td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
  </tr>

  <tr *ngFor="let t of dawDataOnly$ | ngrxPush">
    <td class="spacer border-left"></td>
    <td class="left border-bottom border-right feature-name">
      {{ t.featureName }}
      <span class="feature-description">{{ t.description }}</span>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.EARLY_ADOPTER]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.COLLABORATOR]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.PERSONAL]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.BAND]">check</mat-icon>
    </td>
  </tr>

  <tr>
    <td class="title left border-top border-left border-right" colspan="2">
      COLLABORATION FEATURES
    </td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
  </tr>

  <tr *ngFor="let t of collaborationDataOnly$ | ngrxPush">
    <td class="spacer border-left"></td>
    <td class="left border-bottom border-right feature-name">
      {{ t.featureName }}
      <span class="feature-description">{{ t.description }}</span>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.EARLY_ADOPTER]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.COLLABORATOR]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.PERSONAL]">check</mat-icon>
    </td>
    <td class="border-bottom border-right">
      <mat-icon *ngIf="t[roles.BAND]">check</mat-icon>
    </td>
  </tr>

  <tr>
    <td class="title left border-top border-left border-right" colspan="2">
      ADD ONS
    </td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
    <td class="border-right"></td>
  </tr>

  <tr>
    <td class="spacer border-left border-bottom"></td>
    <td class="left border-bottom border-right feature-name">
      Additional Storage
    </td>

    <ng-container *ngrxLet="selectStorageAddonMonthly$; let a">
      <ng-container *ngIf="a">
        <td class="border-bottom border-right tier-yearly-price">
          {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
          {{ a.interval }}
        </td>
        <td class="border-bottom border-right tier-yearly-price">
          <!--          {{ formatCurrency(a) }} / {{ a.interval_count | storage }} / {{ a.interval }}-->
        </td>
        <td class="border-bottom border-right tier-yearly-price">
          {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
          {{ a.interval }}
        </td>
        <td class="border-bottom border-right tier-yearly-price">
          {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
          {{ a.interval }}
        </td>
      </ng-container>
    </ng-container>
  </tr>
</table>
<p class="push-top-20">
  <sup>*</sup> File storage used by creating tracks as a collaborator count
  against the project owner's account.
</p>
<p class="push-top-20">
  <sup>+</sup> Account is removed if not purchased after 30 days.
</p>
